module.exports = __webpack_public_path__ + "static/media/chair_hero.1078499f.jpg";